import {PAYMENT_OS_ERRORS, getCreditCardErrorText} from '@optimaxdev/utils';

import {logWithSentry} from 'libs/sentry/sentry';

import {CreateTokenFromPaymentOSType} from 'types/paymentOSType';

/**
 * function to validate expiry
 */
export function validateExpirationDate(expirationDate: string) {
    const splitExpirationDate = expirationDate.split('/');
    const cardYear = Number(splitExpirationDate[1]);
    const cardMonth = Number(splitExpirationDate[0]);
    const date = new Date();

    if (date.getFullYear() > cardYear) {
        return false;
    } else if (date.getFullYear() === cardYear) {
        return cardMonth >= date.getMonth() + 1;
    }

    return true;
}

/**
 * Create token with card details from PaymentOS Secure Fields
 *
 * @param {CreateTokenFromPaymentOSType} cardDetails - additional card information
 */
export const createTokenFromPaymentOS = async ({
    additionalData,
    cardNumberField,
    environment,
    onReject,
    onSuccess,
}: CreateTokenFromPaymentOSType) => {
    try {
        await window.POS.createToken(cardNumberField, {
            additionalData,
            environment,
        }).then((data: string | {error: {[key in string]: string}}) => {
            if (typeof data !== 'string') {
                const [[fieldName, value]]: Array<Array<string>> = Object.entries(data.error);

                onReject({errorMessage: getCreditCardErrorText(value), fieldName});
                return;
            }

            try {
                const {
                    encrypted_cvv: cvv,
                    expiration_date: expirationDate,
                    token,
                } = JSON.parse(data);

                if (validateExpirationDate(expirationDate)) {
                    onSuccess({cvv, token});
                } else {
                    onReject({errorMessage: PAYMENT_OS_ERRORS.EXPIRY, fieldName: 'expiry'});
                }
            } catch (error) {
                logWithSentry(error, {data, msg: 'Error JSON parsing data'});
            }
        });
    } catch (error) {
        logWithSentry(error);
    }
};
